import { trackClientEvent } from 'analytics/analytics'

const INTENTS = ['deliberate', 'automatic', 'unknown'] as const

export function trackPreviouslyViewedOffersIntentCounts(items: Array<Pick<App.MultiCartItem, 'intent' | 'state'>>): void {
  const visibleItems = items.filter(item => item.state !== 'deleted')
  for (const intent of INTENTS) {
    const count = visibleItems.filter(item => (item.intent ?? 'unknown') === intent).length
    // Numeric actions follow the existing client-event count/duration convention.
    trackClientEvent({
      subject: `previously_viewed_offers_${intent}_count`,
      action: String(count),
      category: 'multi_cart',
      type: 'nonInteraction',
    })
  }
}
